import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiOrigin';
import { CompanyBrand, DEFAULT_COMPANY_BRAND, normalizeCompanyBrand } from '../brand/types';

interface BrandingApiResponse {
  found?: boolean;
  brand?: Partial<CompanyBrand>;
}

export const fetchBrandBySlug = async (slug: string): Promise<CompanyBrand> => {
  const normalizedSlug = slug.trim().toLowerCase();
  if (!normalizedSlug) {
    return DEFAULT_COMPANY_BRAND;
  }

  try {
    const response = await axios.get<BrandingApiResponse>(
      `${getApiBaseUrl()}/companies/branding/${encodeURIComponent(normalizedSlug)}`
    );
    return normalizeCompanyBrand(response.data?.brand);
  } catch {
    return DEFAULT_COMPANY_BRAND;
  }
};

export const fetchBrandForAuthenticatedUser = async (token: string): Promise<CompanyBrand | null> => {
  try {
    const response = await axios.get(`${getApiBaseUrl()}/auth/profile`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (response.data?.brand) {
      return normalizeCompanyBrand(response.data.brand as Partial<CompanyBrand>);
    }
    return null;
  } catch {
    return null;
  }
};
